import { Component, inject, Input } from '@angular/core';
import { Configuration } from '../../../../../models/configurators-2d/applications/fence/configuration';
import { FenceService } from '../../../../../services/configurators-2d/applications/fence.service';

@Component({
  selector: 'ng-fence-preview-environment',
  templateUrl: './fence-preview-environment.component.html',
  styleUrl: './fence-preview-environment.component.scss',
})
export class FencePreviewEnvironmentComponent {
  private readonly fenceService = inject(FenceService);

  protected get configuration(): Configuration {
    return this.fenceService.configuration;
  }

  /**
   * Getter de détermination de l'arrière-plan à afficher
   * @returns objet style
   */
  protected get backgroundImageUrl(): string {
    return this.fenceService.imgPath(this.configuration.location.picture.path);
  }
}
